import { ShortDataModel } from 'Models'
import { Deserialize } from 'cerialize'

export const convertObjectToShortData = (object): ShortDataModel =>
	Object.keys(object).length
		? Deserialize({ id: Object.keys(object)[0], name: Object.values(object)[0] })
		: new ShortDataModel()
